import React, { useEffect, useState } from "react";
import "./assests/css/style.css";
import imgurl from "./assests/images/imgurl";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { replace, useLocation, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import { useTimer } from "react-timer-hook";
import axios from "axios";
import AlertComp from "./Alert";
import { Card, CardContent } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import mobileIcon from "./assests/images/newimages/ic-contact-mobile.svg";
import EditIcon from "@mui/icons-material/Edit";
import MainLoader from "./components/MainLoader";
import { useSelector, useDispatch } from 'react-redux'
import i18next from 'i18next';
import LanguageSelector from "./LanguageSelector";
import { postApi } from "./api/services";
import { setgender } from "./Reducers/reducer";
import { setLanguage } from "./Redux/languageSlice";
import { serviceDown, trackEvent } from "./utils/UtilityFunctions";
import MobileHeader from "./components/MobileHeader";

// const time = new Date();
//     time.setSeconds(time.getSeconds() + 300);
function OtpPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const [otp, setOtp] = useState("");
  const [expired, setExpired] = useState(false);
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("Test");
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const locale = useSelector((state) => state.language.langData);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, [isMobile]);

  useEffect(() => {
    console.log("locationnnn", location);
    if(!location?.state?.from){
      let checkUserData = JSON.parse(sessionStorage.getItem("checkUser"));
      console.log("checkUserData", checkUserData);
      if(checkUserData){
        // navigate('imgupload')
      }
    }
    return () => {
      if(location?.state?.from){
        location.state = null
      }  
    }
  }, [location])

  useEffect(() => {
    const storedStartTime = localStorage.getItem("otpStartTime");
    if (storedStartTime) {
      const elapsed = Math.floor(
        (Date.now() - parseInt(storedStartTime)) / 1000
      );
      if (elapsed < 300) {
        setTimeLeft(300 - elapsed);
      } else {
        setExpired(true);
      }
    } else {
      resetTimer();
    }
  }, []);

  // Reset the timer when the page/component loads
  useEffect(() => {
    resetTimer();
  }, []);

  useEffect(() => {
    if (expired || timeLeft <= 0) {
      setExpired(true);
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, expired]);

  function resetTimer() {
    localStorage.setItem("otpStartTime", Date.now().toString());
    setTimeLeft(300);
    setExpired(false);
  }

  function resetOTP() {
    setLoading(true)
    let data = JSON.stringify({
      user_no: localStorage.getItem("phno"),
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://aloxa.ai/flaskservice/getotp",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setLoading(false)
        setExpired(false);
      })
      .catch((error) => {
        setLoading(false)
        setalertmsg(
          "Error sending verification code. Please check Phone number."
        );
        setalertopen(true);
        setTimeout(() => {
          setalertopen(false);
        }, 4000);
        console.log(error);
      });
  }

  // function verifyOTP() {
  //   // Set loading state to true before making the API call
  //   setLoading(true); // Show loader

  //   let data = JSON.stringify({
  //     user_no: localStorage.getItem("phno"),
  //     otp: otp,
  //   });

  //   let no = {
  //     mobile_number: "+" + localStorage.getItem("phno"),
  //   };

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: "https://aloxa.ai/flaskservice/verifyotp",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {

  //       var myHeaders = new Headers();
  //       myHeaders.append("Content-Type", "application/json");

  //       var raw = JSON.stringify({
  //         phone_number: parseInt(localStorage.getItem("phno")),
  //       });

  //       var requestOptions = {
  //         method: "POST",
  //         headers: myHeaders,
  //         body: raw,
  //         redirect: "follow",
  //       };
        
  //       // verifyotp()

  //       fetch(
  //         "https://aloxa.ai/flaskservice/check_user",
  //         requestOptions
  //       )
  //         .then((response) => response.text())
  //         .then((result) => {
  //           console.log("resultttttt", result);
            
  //           sessionStorage.setItem("checkUser", result);
  //           if (JSON.parse(result).user_exists) {
  //             navigate("/onboardingslider");
  //             // localStorage.setItem("valid_user", true);
  //             localStorage.setItem(
  //               "user_id",
  //               JSON.parse(result).user_id.user_id
  //             );
  //           } else {
  //             var myHeaders = new Headers();
  //             myHeaders.append("Content-Type", "application/json");

  //             var raw = JSON.stringify({
  //               phone_number: parseInt(localStorage.getItem("phno")),
  //               channel: window.cordova ? 'mobile' : 'webapp',
  //             });

  //             var requestOptions = {
  //               method: "POST",
  //               headers: myHeaders,
  //               body: raw,
  //               redirect: "follow",
  //             };

  //             fetch(
  //               "https://aloxa.ai/flaskservice/create_user",
  //               requestOptions
  //             )
  //               .then((response) => response.text())
  //               .then((result) => {
  //                 navigate("/onboardingslider");
  //                 // localStorage.setItem("valid_user", true);
  //                 localStorage.setItem(
  //                   "user_id",
  //                   JSON.parse(result).user_id.user_id
  //                 );
  //               })
  //               .catch((error) => console.log("error", error))
  //               .finally(() => {
  //                 setLoading(false); // Stop loader after the API call is finished
  //               });
  //           }
  //         })
  //         .catch((error) => {
  //           console.log("error", error);
  //         })
  //         .finally(() => {
  //           setLoading(false); // Stop loader after the API call is finished
  //         });
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
        // setalertmsg("Verification code failed. Please try again.");
        // setalertopen(true);
        // setTimeout(() => {
        //   setalertopen(false);
        // }, 4000);
  //     })
  //     .finally(() => {
  //       setLoading(false); // Stop loader after the API call is finished
  //     });
  // }

  const verifyOTP = async () => {
    setLoading(true)
    let params = {
      user_no: localStorage.getItem("phno"),
      otp: otp,
    }
    try{
      let res = await postApi('verifyotp', params)
      if(res) {
        if(res?.error) {
          setLoading(false)
          await trackEvent('code_verification_completed', 'fail', res?.error, localStorage.getItem('phno'))
          setalertmsg(i18next.t("Verification code failed. Please try again."));
          setalertopen(true);
          setTimeout(() => {
            setalertopen(false);
          }, 4000);      
        } else {
          await trackEvent('code_verification_completed', 'success', '', localStorage.getItem('phno'))
          if(localStorage.getItem('user_role').toUpperCase() === 'DOCTOR'){
            // checkDoctor()
            navigate("/clients")
          } else if(localStorage.getItem('user_role').toUpperCase() === 'NURSE'){
            // getNurse()
            navigate("/homepage")
          } else {
            checkUser()
          }
        }
      }
    } catch(err) {
      await trackEvent('code_verification_completed', 'fail', err, localStorage.getItem('phno'))
      setLoading(true)
      setalertmsg(i18next.t("Verification code failed. Please try again."));
      setalertopen(true);
      setTimeout(() => {
        setalertopen(false);
      }, 4000);
      console.log("err", err)
    }
  }

  const checkUser = async () => {
    let params = {
      phone_number: parseInt(localStorage.getItem("phno")),
    }
    try {
      let res = await postApi('check_user', params)
      if(res) {  
        sessionStorage.setItem("checkUser", JSON.stringify(res));
        if (res?.Active_status === true) {
          await trackEvent('check_user', 'success', '', localStorage.getItem('phno')) 
          // navigate("/onboardingslider");
          localStorage.setItem("user_id", res.user_id.user_id);
          localStorage.setItem("test_taken", res.test_taken)
          if(res && res.preferred_language){
            dispatch(setLanguage(res.preferred_language))
            updateLang(res.user_id.user_id, res.preferred_language)
          } else {
            updateLang(res.user_id.user_id)
          }
          if(res && res.gender){
            localStorage.setItem('gender', res.gender.toLowerCase())
            dispatch(setgender(res.gender.toLowerCase()))
          }          
        } else if (res?.Active_status === false) {
          await trackEvent('check_user', 'success', '', localStorage.getItem('phno'))
          setLoading(false)
          let content = 
            `
              <p>Your account has been deleted as per your request. For any assistance, please contact our Admin.</p>
              <p>Email - contact@alopexia.com</p>
            `
          swal({
            icon: 'warning',
            content: {
              element: 'div',
              className: 'deletedAccountMsg',
              attributes: {
                innerHTML: `${content}`
              }
            }
          }).then(() => {
            navigate(-1)
          })
        } else {
          createUser()
        }       
      }
    } catch (err) {
      console.log("err", err);
      await trackEvent('check_user', 'fail', err, localStorage.getItem('phno'))
      setLoading(false)
      serviceDown('/loginpage')     
    }
  }

  const checkDoctor = async () => {
    let params = {
      phone_number: localStorage.getItem("phno")
    }
    console.log("get_doctor_by_phone params", params);
    try {
      let res = await postApi('get_doctor_by_phone', params)
      console.log("get_doctor_by_phone res", res);
      setLoading(false)
      if(res?.doctor_exist){
        sessionStorage.setItem("checkUser", JSON.stringify(res));
        localStorage.setItem('doctorobj', JSON.stringify(res))
        localStorage.setItem('doctorLogged', true)
        navigate("/clients")
      } else {
        // navigate("/doctorregistration")
        swal({
          title: i18next.t('Clinic Not Registered'),
          text: i18next.t('Your clinic is not registered on this platform. To proceed, please contact your administrator for access.'),
          icon: 'warning'
        }).then(() => {
          navigate('/loginpage')
        })
      }
    } catch (err) {
      console.log("err", err);
      // await trackEvent('check_user', 'fail', err, localStorage.getItem('phno'))
      setLoading(false)
      serviceDown('/loginpage') 
    }
  }

  const getNurse = async () => {
    let params = {
      phone_number: localStorage.getItem("phno")
    }
    console.log("get_nurse_by_phone params", params);
    try {
      let res = await postApi('get_nurse_by_phone', params)
      console.log("get_nurse_by_phone res", res);
      setLoading(false)
      if(res?.error){
        setLoading(false)
        serviceDown(navigate, '/loginpage')
      } else if(res.nurse_exist && !res.nurse_exist) {
        swal({
          title: i18next.t('Clinic Not Registered'),
          text: i18next.t('Your clinic is not registered on this platform. To proceed, please contact your administrator for access.'),
          icon: 'warning'
        }).then(() => {
          navigate('/loginpage')
        })
      } else {
        sessionStorage.setItem("checkUser", JSON.stringify(res));
        localStorage.setItem('doctorobj', JSON.stringify(res))
        localStorage.setItem('doctorLogged', true)
        navigate("/homepage")
      }
    } catch (err) {
      console.log("err", err);
      setLoading(false)
      serviceDown('/loginpage') 
    }  
  }

  const createUser = async () => {
    let params = {
      phone_number: localStorage.getItem("phno"),
      channel: window.cordova ? 'mobile' : 'webapp',
    }
    try {
      let res = await postApi('create_user', params)
      if(res) {
        // navigate("/onboardingslider");
        await trackEvent('user_registered', 'success', '', localStorage.getItem('phno'))
        localStorage.setItem("user_id", res?.user_id?.user_id);
        updateLang(res?.user_id?.user_id, 'newUser');
      }
    } catch (err) {
      console.log("err", err);
      await trackEvent('user_registered', 'fail', err, localStorage.getItem('phno'))
      setLoading(false)
      serviceDown('/loginpage')
    } finally {
      setLoading(false)
    }
  }

  const updateLang = async (id, lang) => {
    setLoading(true)
    let params = {
      user_id: id,
      preferred_language: lang ? lang : locale
    }
    try {
      const res = await postApi("update_preferred_language", params)
      if(res.message){
        await trackEvent('language_change', 'success', res.message, localStorage.getItem('phno'))
        if(lang === 'newUser') {
          navigate("/onboardingslider"); 
        } else {
          localStorage.getItem('isDoctor') ? navigate("/doctorregistration") : navigate("/reports"); 
        }
      }
    } catch(err) {
      console.log("err", err);
      await trackEvent('language_change', 'fail', err, localStorage.getItem('phno'))  
      serviceDown(navigate, '/loginpage')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {loading && <MainLoader />}
      <div className="otppage">
        {/* <div className="otpbgimg toppg">
                </div> */}

        <div className="w-100">
          <div className="languageOtpContainer">
            <div className="d-flex justify-content-start align-items-center gobackbtn otpBackbtn">
              <span
                className="backButtonDiv"
                onClick={() => navigate("/loginpage", { replace: true })}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
            <div className={window.cordova ? 'language-select-div' : 'language-select-div web'}>
              <LanguageSelector from={'OtpPage'}/>
               {isMobile && <MobileHeader showDrawer={true}/>}      
            </div>
          </div>
         

          <Card className="otpcard otpMainCard">
            <CardContent className="pb-16px w-100">
              {
                isMobile && 
                  <div className="loginpglogo mt-5px">
                    <img src={imgurl.hairlossaiLogo} className="mb-4 mt-0 otpLogo" alt="New Logo"/>
                  </div>
              }
              <div className="otppgtext">
                <p className="mb-5px otpText">{i18next.t("A code has been sent to your mobile number by SMS. Enter the code to proceed.")}</p>
                <p className="editNumberField">
                  {"+"}
                  {localStorage.getItem("phno")}{" "}
                  <span>
                    <EditIcon onClick={() => navigate("/loginpage")} />
                  </span>
                </p>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <span className="mobileBorder">
                  <img src={mobileIcon}></img>
                </span>
              </div>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <p className="otpCode">{i18next.t("Enter 4 Digit Code")}</p>
                </Grid>
              </Grid>

              <Grid container spacing={0} className="otptextfield">
                {/* <Grid item xs={3}>
                        <TextField id="outlined-basic" label="" variant="outlined" className="bluefield" />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id="outlined-basic" label="" variant="outlined" className="whitefield" />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id="outlined-basic" label="" variant="outlined" className="whitefield" />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id="outlined-basic" label="" variant="outlined" className="whitefield" />
                    </Grid> */}

                <div className="otpFieldDiv">
                  <OtpInput
                    className="otp-input"
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    renderSeparator={<span> </span>}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>
              </Grid>

              <div className="otpinfotext">
                {/* <p>I didn’t receive the code,</p> */}
                {!expired ? (
                  <div className="otpinfotextblue">
                    {i18next.t("Resend Verification Code in:")} {Math.floor(timeLeft / 60)}:
                    {(timeLeft % 60).toString().padStart(2, "0")}
                  </div>
                ) : (
                  <div className="otpinfotextblue cursor-pointer" onClick={resetOTP}>
                    {i18next.t("Resend Verification Code")}
                  </div>
                )}
              </div>

              <Button
                variant="contained"
                className="commonButton mt-20px"
                onClick={() => verifyOTP()}
              >
                {i18next.t("Next")}
              </Button>
            </CardContent>
          </Card>

          {/* <Grid className="btnssection">
                        <Grid item xs={6}>
                            <div className="prevbtn">
                                <Button variant="contained" onClick={() => { navigate("/") }}>
                                    <div className="prevbtntext">
                                        <img src={imgurl.backarrow} alt="Backward arrows" />
                                        <p> Previous </p>
                                    </div>

                                </Button>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className="nextbtn">
                                <Button variant="contained" onClick={() => verifyOTP()}>
                                    <div className="nextbtntext">
                                        <p> Next </p>
                                        <img src={imgurl.arrows} alt="Forward arrows" />
                                    </div>

                                </Button>
                            </div>
                        </Grid>
                    </Grid> */}
        </div>

        {/* <div className='shapeblue'>
                    <img src={imgurl.shapeblue} alt="Blue shape" />
                </div> */}

        <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
      </div>
    </>
  );
}

export default OtpPage;
